import { render, staticRenderFns } from "./VolunteerReported.vue?vue&type=template&id=65e6c15a"
import script from "./VolunteerReported.vue?vue&type=script&lang=js"
export * from "./VolunteerReported.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports